import { Shortcut } from 'components/HOC/decorateWithShortcut';
import { actionType } from 'utils/constants';

function action(this: Shortcut) {
  const { id } = this;
  const buttonId = document.getElementById(id);
  if (buttonId) buttonId.click();
}
const hotActions: Shortcut[] = [
  {
    id: actionType.DELETE_DOCUMENT,
    code: 'l+d',
    action,
  },
  {
    id: actionType.PREV_Q1_TAB,
    code: 'ctrl+left',
    alwaysShow: true,
    action,
  },
  {
    id: actionType.NEXT_Q1_TAB,
    code: 'ctrl+right',
    alwaysShow: true,
    action,
  },
  {
    id: actionType.MANUAL_REASSIGN_DOCUMENTS,
    code: 'l+n',
    action,
  },
  {
    id: actionType.VALIDATE,
    code: 'l+v',
    action,
  },
  {
    id: actionType.CLOSE_Q3,
    code: 'ctrl+q',
    alwaysShow: true,
    action,
  },
  {
    id: actionType.MOVE_IN_Q3,
    code: 'shift+arrow keys',
    alwaysShow: true,
    action,
  },
  {
    id: actionType.SAVE_DOCUMENT,
    code: 'F4',
    action,
  },
  {
    id: actionType.CLOSE_DOCUMENT,
    code: 'F3',
    alwaysShow: true,
    action,
  },
  {
    id: actionType.SEND_TO_WORKFLOW,
    code: 'F11',
    action,
    isAction: true,
  },
  {
    id: actionType.EXPORT_TO_SAP,
    code: 'F6',
    action,
    isAction: true,
  },
];

const HotActionDocumentList = [
  {
    id: actionType.COPY_CELL,
    code: 'ctrl+left',
    alwaysShow: true,
    action,
  },
  {
    id: actionType.SEND_TO_WORKFLOW,
    code: 'F11',
    action,
    isAction: true,
  },
];

export { hotActions, HotActionDocumentList };
